// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__q1O6B","controls":"styles_controls__R1zn9","pagination":"styles_pagination__DK_8J"};